<template>
  <modal 
    name="cs-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'620px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        Client source
      </div>

      <a href="#"
        v-on:click.prevent="close"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body" v-if="clientSource != null">

      <div class="text-base">
        Type
      </div>

      <div class="form-line">
        <select v-model="clientSource.source_type" class="select-standard h-10">
          <option :value="null">Please select a source type</option>
          <option value="friend">From a friend</option>
          <option value="family">Family</option>
          <option value="self">Self-sourced</option>
          <option value="financial-planner">Financial planner</option>
          <option value="accountant">Accountant</option>
          <option value="property-developer">Property developer</option>
          <option value="real-estate-agent">Real estate agent</option>
          <option value="client">Client</option>
          <option value="solicitor">Solicitor</option>
          <option value="other">Other</option>
        </select>
      </div>

      <template v-if="clientSource.source_type == 'other'">
        <div class="label-line text-sm">
          Please describe your source
        </div>

        <div class="form-line">
          <input type="text" class="input-standard" v-model="clientSource.source_type_other" />
        </div>
      </template>

      <template v-if="clientSource.source_type != null && clientSource.source_type != 'self'">
        <div class="label-line flex flex-wrap">
          <div class="w-1/2 pr-4">
            <div class="text-sm">
              First name
            </div>

            <div class="form-line">
              <input type="text" class="input-standard" v-model="clientSource.first_name" />
            </div>
          </div>

          <div class="w-1/2 pl-4">
            <div class="text-sm">
              Last name
            </div>

            <div class="form-line">
              <input type="text" class="input-standard" v-model="clientSource.last_name" />
            </div>
          </div>
        </div>

        <div class="label-line text-sm">
          Email
        </div>

        <div class="form-line">
          <input type="text" class="input-standard" v-model="clientSource.email" />
        </div>

        <div class="label-line text-sm">
          Mobile
        </div>

        <div class="form-line">
          <input type="text" class="input-standard" v-model="clientSource.mobile" />
        </div>
      </template>


      <div class="button-line flex items-center justify-between">
        <SubmitButton2 :onClick="submit" :loading="loading" label="Save" />
        <a href="#" class="text-gray-600 hover:underline" @click.prevent="deleteClientSource">Delete</a>
      </div>

    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        loading     : false,
        clientSource: null,
      }
    },

    methods : {
      
      beforeOpen(event) {
        this.loading      = false
        this.clientSource = event.params.clientSource 
      },

      opened(event) {

      },

      close() {
        this.$modal.hide('cs-modal')
      },

      submit() {
        let valid = true
        
        if(valid) {
          this.loading = true
          this.apiPost({
            clientSource : this.clientSource
          }, 'client-source/edit', () => {
            this.loading = false
            this.$modal.hide('cs-modal')
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Client source saved."
            })

            EventBus.$emit('get-data')
            this.close()
          })
        }
      },

      deleteClientSource() {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this client source?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                clientSourceId : this.clientSource.id
              }, 'client-source/delete', () => {
                this.$modal.hide('confirm-modal')
                EventBus.$emit('get-data')
                this.close()
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Client source deleted successfully"
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      }
    }
  }
</script>